import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";
import { useLang } from "@/context/LangContext";
import { cn } from "@/lib/utils";

const SHOW = { id: "Tampilkan kata sandi", en: "Show password", ar: "إظهار كلمة المرور", fr: "Afficher le mot de passe", de: "Passwort anzeigen", es: "Mostrar contraseña", ru: "Показать пароль", zh: "显示密码", ja: "パスワードを表示", ko: "비밀번호 표시", hi: "पासवर्ड दिखाएं" };
const HIDE = { id: "Sembunyikan kata sandi", en: "Hide password", ar: "إخفاء كلمة المرور", fr: "Masquer le mot de passe", de: "Passwort verbergen", es: "Ocultar contraseña", ru: "Скрыть пароль", zh: "隐藏密码", ja: "パスワードを非表示", ko: "비밀번호 숨기기", hi: "पासवर्ड छिपाएं" };

// Password field with an eye toggle to reveal/hide the typed value.
export const PasswordInput = ({ className, "data-testid": testId, ...props }) => {
  const { tc } = useLang();
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input {...props} type={show ? "text" : "password"} data-testid={testId} className={cn("pe-12", className)} />
      <button type="button" onClick={() => setShow((s) => !s)} tabIndex={-1}
        aria-label={tc(show ? HIDE : SHOW)} aria-pressed={show} title={tc(show ? HIDE : SHOW)}
        data-testid={testId ? `${testId}-toggle` : undefined}
        className="absolute inset-y-0 end-0 flex w-12 items-center justify-center rounded-e-xl text-muted-foreground transition-colors hover:text-primary focus-visible:outline-none focus-visible:text-primary">
        {show ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}
      </button>
    </div>
  );
};
